export default __webpack_public_path__ + "images/Image11.81edb008.png";